import React from "react";
import { useFormikContext } from "formik";
import ConfirmLeaveDialog from "components/common/ConfirmLeaveDialog";
const WindowLeaveMessage = ({ ignoredRoutes }) => {
  const { dirty } = useFormikContext();
  return dirty ? /* @__PURE__ */ React.createElement(
    ConfirmLeaveDialog,
    {
      question: "Are you sure you want to leave the page? Any unsaved changes will be lost.",
      ignoredRoutes
    }
  ) : null;
};
export default WindowLeaveMessage;
